export class Configurations{
    id:number;
    accountId:number;
    code:string;
    description:string;
    deviceId:number;
    eyeSegment?:string;
    diseaseCategory?:string;
    status:boolean=true;
}